<nav
  class="sidebar bg-white mt-4 overflow-hidden border-0 h-[calc(100vh-4rem)]"
  [class.nz-menu-inline-collapsed]="!active && !isHovered"
  (mouseenter)="isHovered = true"
  (mouseleave)="isHovered = false"
>
  <div class="flex flex-col h-full">
    <!-- Menu area (Scrollable) -->
    <div class="grow overflow-y-auto">
      <ul
        nz-menu
        nzMode="inline"
        [nzInlineCollapsed]="!active && !isHovered"
        class="border-0"
      >
        <ng-container *ngFor="let item of menuItems">
          <!-- Single Menu Item -->
          <li
            *ngIf="!item.children"
            nz-menu-item
            [nzSelected]="activeButton === item.name"
            [routerLink]="item.link"
            routerLinkActive="ant-menu-item-selected"
            class="hover:text-primary"
            [id]="'menu-' + item.name.toLowerCase().split(' ').join('-')"
          >
            <span nz-icon class="mr-2">
              <img
                [src]="activeButton === item.name ? item.icon?.active : item.icon?.default"
                alt=""
                width="20"
              />
            </span>
            <span>{{ item.label }}</span>
          </li>

          <!-- Submenu Item -->
          <li
            *ngIf="item.children"
            nz-submenu
            [nzTitle]="titleTpl"
            [nzOpen]="item.open"
            class="hover:text-primary"
            [id]="'menu-' + item.name.toLowerCase().split(' ').join('-')"
          >
            <ng-template #titleTpl>
              <span nz-icon class="mr-2">
                <img
                  [src]="activeButton === item.name ? item.icon?.active : item.icon?.default"
                  alt=""
                  width="20"
                />
              </span>
              <span class="hover:text-primary">{{ item.label }}</span>
            </ng-template>
            <ul>
              <ng-container *ngFor="let subItem of item.children">
                <li
                  *ngIf="(subItem.label !== 'Simulator' || isShowSimulator) && (subItem.name !== 'Document' || isShowDoc)"
                  nz-menu-item
                  [nzSelected]="activeButton === subItem.name"
                  [routerLink]="subItem.link"
                  routerLinkActive="ant-menu-item-selected"
                  class="hover:text-primary"
                  [id]="'menu-' + subItem.name.toLowerCase().split(' ').join('-')"
                >
                  {{ subItem.label }}
                </li>
              </ng-container>
            </ul>
          </li>
        </ng-container>
      </ul>
    </div>

  </div>
</nav>
